export default __webpack_public_path__ + "static/media/Redspray.4c8b2210.jpg";